// ConstantsFinancialCalculator.js
export const SERVER_URL = "https://do-calculate.com/api";

export const financialCalculators = [
  {
    name: "Kalkulator Rasio Harga terhadap Laba",
    link: "/calculator/id/pe-ratio/",
    description:
      "Kalkulator rasio harga terhadap laba menghitung rasio harga terhadap laba perusahaan berdasarkan nilai pasar saham dan laba per saham.",
    showMain: true,
  },
  {
    name: "Kalkulator Dampak Inflasi terhadap Uang",
    link: "/calculator/id/inflation/",
    description:
      "Kalkulator dampak inflasi menghitung jumlah uang yang kehilangan nilainya akibat inflasi antara dua periode waktu yang berbeda.",
    showMain: true,
  },
  {
    name: "Kalkulator Google Adsense",
    link: "/calculator/id/google-adsense/",
    description:
      "Dengan kalkulator Google Adsense ini, kami bertujuan membantu Anda menghitung pendapatan yang dapat Anda peroleh dari program Google Adsense.",
    showMain: true,
  },
  {
    name: "Kalkulator Pajak Pertambahan Nilai",
    link: "/calculator/id/vat/",
    description:
      "Gunakan kalkulator pajak untuk menghitung pajak penjualan dan pajak pembelian serta melihat pajak bulanan untuk bisnis dengan mudah dan dapat dilakukan secara online melalui kalkulator pajak elektronik.",
    showMain: true,
  },
  {
    name: "Konversi Mata Uang - Konverter Mata Uang",
    link: "/calculator/id/currency_list/",
    description: "Lihat semua kalkulator keuangan yang tersedia untuk konversi antar mata uang.",
    showMain: true,
  },
  {
    name: "Harga Emas Hari Ini Langsung",
    link: "/calculator/id/gold-prices/",
    description: "Lihat semua kalkulator keuangan yang tersedia untuk konversi antar mata uang.",
    showMain: true,
  },
  {
    name: "Kalkulator Penjualan Bersih",
    link: "/calculator/id/net-sales-calculator/",
    description:
      "Hitung penjualan bersih dari total penjualan setelah mengurangi retur penjualan dan potongan yang diizinkan.",
    showMain: true,
  },
  {
    name: "Kalkulator Konsumsi Bahan Bakar",
    link: "/calculator/id/fuel-cost-calculator/",
    description:
      "Kalkulator ini menghitung jumlah bahan bakar yang dibutuhkan dan biayanya berdasarkan jarak, efisiensi bahan bakar, dan harga bahan bakar.",
    showMain: false,
  },
  {
    name: "Kalkulator Diskon",
    link: "/calculator/id/discount-calculator/",
    description:
      "Hitung jumlah diskon dan harga akhir setelah menerapkan persentase diskon pada harga total. Kalkulator ini menyediakan cara mudah dan cepat untuk mengetahui jumlah diskon dan uang yang akan Anda hemat.",
  },
  {
    name: "Kalkulator Upah Per Jam dari Gaji Bulanan",
    link: "/calculator/id/hourly-salary-calculator/",
    description:
      "Hitung upah per jam berdasarkan gaji bulanan Anda dan jumlah jam kerja harian. Kalkulator ini menyediakan cara mudah dan cepat untuk mengetahui berapa penghasilan Anda per jam.",
  },
  {
    name: "Kalkulator Upah Harian dari Gaji Bulanan",
    link: "/calculator/id/daily-salary-calculator/",
    description:
      "Hitung gaji harian Anda berdasarkan gaji bulanan Anda dan jumlah hari kerja dalam sebulan. Kalkulator ini menyediakan cara mudah dan cepat untuk mengetahui berapa penghasilan Anda per hari.",
  },
  {
    name: "Kalkulator Margin Keuntungan",
    link: "/calculator/id/profit-margin-calculator/",
    description:
      "Hitung pendapatan dan keuntungan berdasarkan biaya produk dan margin keuntungan yang diinginkan.",
  },
  {
    name: "Kalkulator Kenaikan Gaji",
    link: "/calculator/id/salary-bonus-calculator/",
    description:
      "Gunakan kalkulator kenaikan gaji untuk menghitung nilai kenaikan yang akan Anda terima berdasarkan persentase tertentu dari gaji pokok Anda.",
  }, 
  // paypal-fee
  {
    name: "Kalkulator Biaya PayPal",
    link: "/calculator/id/paypal-fee/",
    description:
      "Hitung biaya PayPal yang akan Anda bayar saat mengirim atau menerima uang melalui platform PayPal. Kalkulator ini menyediakan cara mudah dan cepat untuk mengetahui jumlah biaya yang akan Anda tanggung.",
  },
  // commission-calculator
  {
    name: "Kalkulator Komisi",
    link: "/calculator/id/commission-calculator/",
    description:
      "Hitung komisi yang akan Anda terima berdasarkan persentase tertentu dari penjualan atau keuntungan. Kalkulator ini menyediakan cara mudah dan cepat untuk mengetahui jumlah komisi yang akan Anda terima.",
  },
];
export default financialCalculators;